export const REPORT_BORDER_RADIUS = '8px';
export const CARD_GAP = '12px';
export const COL_HORIZONTAL_PADDING_OVERRIDE = '6px';
export const DEFAULT_BRAND_COLOR = '#666666';
export const DEFAULT_BRAND_SECONDARY_COLOR = '#666666';
